export default __webpack_public_path__ + "static/media/foysal_rounded.bb0b26e0.png";